import {
    gsap,
    Power2
} from "gsap"
import inView from "in-view"
export default class Preloader {
    constructor() {
        this.container = document.querySelector("#preloader")
        this.events()
        this.observers()
        this.setTL()
    }

    events() {
        let changeLinks = document.querySelectorAll(".change-page")
        changeLinks.forEach(el => {
            el.addEventListener("click", e => {
                e.preventDefault()
                if (el.classList.contains("active")) return false
                let url = el.getAttribute("href")
                this.show(el => {
                    window.location.href = url
                })
            })
        })
    }

    observers() {
        inView('img').on('enter', el => {
            const parent = el.parentNode
            if (!parent.classList.contains("loaded") && !parent.classList.contains("error")) return this.loadImg(el, parent)
        })

    }

    loadImg(el, parent) {
        let _src = el.getAttribute("data-src")
        let _img = new Image()
        _img.onload = () => {
            el.src = _src
            parent.classList.add("loaded")
        }
        _img.onerror = () => parent.classList.add("error")
        _img.src = _src
    }

    show(callback) {
        gsap.to("#app", {
            ease: Power2.easeOut,
            duration: .65,
            opacity: 0
        })
        this.container.classList.remove("loaded")
        gsap.to(this.container, {
            ease: Power2.easeOut,
            display: "block",
            duration: .45,
            opacity: 1,
            scaleX: 1,
            scaleY: 1,
            onComplete: () => {
                if (callback) callback()
            }
        })

    }

    setTL() {
        let obj = {
            projects: 1
        }
        let counter = document.querySelector("#work h1 sup")
        this.tl = gsap.timeline({
            paused: true,
            delay: .5
        }).to(this.container, {
            ease: Power2.easeOut,
            duration: .35,
            opacity: 0,
            display: "none",
            scaleX: 2,
            scaleY: 2,
            onComplete: () => {
                window.scroll(0, 0)
            }
        }, 0).to("#main-header .intro-item", {
            clipPath: "inset(0% 0% 0% 0%)",
            ease: Power2.easeOut,
            duration: 1,
            stagger: 0.125,
            force3D: true,
            y: "0%",
            opacity: 1
        }, .15).to("section .intro-item", {
            clipPath: "inset(0% 0% 0% 0%)",
            ease: Power2.easeOut,
            duration: 1.65,
            force3D: true,
            y: "0%",
            opacity: 1
        }, .85)
        if (counter) {
            this.tl.to(obj, {
                duration: 2,
                ease: Power2.easeOut,
                projects: PROJECTS,
                onUpdate: () => {
                    let number = `(${ obj.projects < 9 ? '0' : '' }${~~obj.projects})`
                    counter.innerText = number
                }
            }, .35)
        }
        this.tl.to("#work-nav", {
            ease: Power2.easeOut,
            duration: 2,
            opacity: 1,
            y: 0
        }, .85).to("#media-container", {
            ease: Power2.easeOut,
            duration: 3,
            opacity: 1,
            y: "0%",
            onStart: () => {
                let video = document.querySelector("#comercial-0 .play-video")
                if (video) video.classList.add("auto")
                else {
                    video = document.querySelector("#video-container video")
                    if (video) video.classList.add("auto")
                }
            }
        }, 1.45)
    }

    hide() {
        this.container.classList.add("loaded")
        return this.tl.play()
    }
}